import React from "react";

const Section2 = ({ url }) => {

  const cards = [
    {
      title: "Your Team Is Working Around Your Software, Not With It",
      desc: "When your processes have to bend to match your tools, productivity suffers. Teams build manual workarounds, duplicate data entry, and use spreadsheets to fill the gaps that your software was supposed to close. This is not a people problem. It is a software problem.",
    },
    {
      title: "Off-the-Shelf Software Grows With Its Vendor, Not With You",
      desc: "SaaS platforms and out-of-the-box solutions are designed to serve thousands of businesses at once. When your business scales, those tools often cannot keep up or force you into expensive enterprise tiers that still do not solve your specific problem.",
    },
    {
      title: "Every Manual Process Is a Scalability Ceiling",
      desc: "What your team manages manually today will become a bottleneck tomorrow. Building the right software infrastructure now is not a cost. It is the foundation your next growth stage is built on.",
    },
  ];

  return (
    <section className="home-section-2">
      <div className="container overflow-hidden">

        <h2 className="s2-title" data-aos="fade-up">
          Why Most Businesses Are Losing Time <br />and Money to the Wrong Software
        </h2>

        <p className="s2-subtitle" data-aos="fade-up" data-aos-delay="100">
          Most businesses do not have a technology problem. They have a fit problem. They are using tools built for the average company, not their company. And over time, the gap between what the software does and what the business needs becomes a hidden operational cost that compounds quietly.
        </p>

        <div className="s2-cards-row" data-aos="fade-up" data-aos-delay="200">
          {cards.map((card, idx) => (
            <div className="s2-card" key={idx}>
              <h3 className="s2-card-title">{card.title}</h3>
              <p className="s2-card-desc">{card.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Section2;